import { LlwythwrRhyngGipio } from './llwythwr.rhyng-gipio';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpTocynRhyngGipio } from './http.tocyn.rhyng-gipio';

export const httpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: LlwythwrRhyngGipio, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpTocynRhyngGipio, multi: true },
];
